export enum DataHook {
  WidgetWrapper = 'Profile-Wrapper',
  GeneralSettingsOverviewModal = 'GeneralSettings-modal',
  EditProfileButton = 'Profile-EditProfileButton',
  LikesReceivedStats = 'Profile-LikesReceivedStats',
  CommentsStats = 'Profile-CommentsStats',
  TopCommentsStats = 'Profile-TopCommentsStats',
  AboutOverlay = 'Profile-AboutOverlay',
  AboutEditModal = 'Profile-AboutEditModal',
  CreatePostLink = 'Profile-CreatePostLink',
  Post = 'Profile-Post',
  PostsLoader = 'Profile-PostsLoader',
  LoadMorePostsButton = 'Profile-LoadMorePostsButton',
  Toast = 'Profile-Toast',
  AboutInputDialogPrimaryButton = 'InputDialog-primaryButton',
  DiscardButton = 'Profile-DiscardButton',
  PublishButton = 'Profile-PublishButton',
  EditAboutButton = 'Profile-EditAboutButton',
  EmptyEditor = 'Profile-EmptyEditor',
}
